import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { GetCoachPhoneNumberWS } from "@app/core/coach/infrastructure/get-coach-phone-number.ws";

import { CoachRepo } from "@app/core/coach/domain/coach.repo";

/**
 * Repository used to get match detail.
 */
@Injectable()
export class CoachRepoImpl implements CoachRepo {
  constructor(private getCoachPhoneNumberWS: GetCoachPhoneNumberWS) {}

  getCoachPhoneNumber(token: string, matchid: string): Observable<string> {
    return this.getCoachPhoneNumberWS.execute(token, matchid);
  }
}
